
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linejoin":"round","d":"M6 9H3v6h3l5 4V5L6 9z"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M18.5 5.5a9.192 9.192 0 010 13M15 8a5.657 5.657 0 010 8"}})])])
          )
        }
      }
    